import { useAuthStore } from '@/features/auth/stores/authStore'
import { useHasRedeemedKey } from '@/features/solution-browser/hooks/useActivationKey'

/**
 * Free vs paid, decided by activation keys: a user with any REDEEMED key has bought a test series.
 * - isPaidUser: known to hold a redeemed key
 * - isFreeUser: known NOT to hold one (false while loading or on error)
 * Gate content on `!isPaidUser` so nothing paid flashes while the keys load.
 */
export function useActivationAccess() {
  const userId = useAuthStore((s) => s.userId) ?? undefined
  const { hasRedeemedKey, isLoading, isError, refetch } = useHasRedeemedKey(userId)

  return {
    isPaidUser: hasRedeemedKey,
    isFreeUser: !isLoading && !isError && !hasRedeemedKey,
    isLoading,
    isError,
    refetch,
  }
}
